import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import MasonryServicesFlashImages from "./MasonryServicesFlashImages";


class MasonryServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masonryServicespage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "masonryServices",
    }).then((entries) => {
      this.setState({ masonryServicespage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(masonryServicesDescription) {
    return {
      __html: marked(masonryServicesDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.masonryServicespage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.masonryServicespage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 style={{textTransform: "uppercase"}}>{item.fields.masonryServicesTitle}</h1>
                    <h2 className="lead">{item.fields.masonryServicesShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.masonryServicesImg.fields.file.url}
                          alt="container design"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.masonryServicesDescription
                        )}>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

                {/*<div>
                    <h1 style={{"text-align":"center"}}>Looking for a Unique Gift Ideas?</h1>
                    <HomeVideo/>
          </div>*/}

          <div className="pt-4">
            <Link to="/masonry-services-gallery"><MasonryServicesFlashImages/></Link>  
          </div>

      {/* <div className="pt-4">
      <Link to="/container-design-program-gallery"><button className="btn btn-primary">View Gallery</button></Link>
      </div> */}
      </div>
      
      </>
    );
  }
}

export default MasonryServices;
